var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FDCA40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3308 15.9876C25.3403 21.13 21.1466 25.3349 16.0042 25.3385C13.7832 25.3401 11.7431 24.5659 10.1399 23.272C9.72303 22.9355 9.69187 22.3108 10.0707 21.9319L10.4947 21.5079C10.8187 21.1839 11.336 21.1485 11.6949 21.4332C12.8761 22.3705 14.3709 22.93 15.9974 22.93C19.825 22.93 22.9222 19.8322 22.9222 16.0052C22.9222 12.1776 19.8244 9.08048 15.9974 9.08048C14.1603 9.08048 12.4918 9.79437 11.2529 10.9596L13.163 12.8697C13.5424 13.2491 13.2737 13.8977 12.7373 13.8977H7.26621C6.93364 13.8977 6.66406 13.6281 6.66406 13.2955V7.82451C6.66406 7.28806 7.31266 7.01939 7.69201 7.39871L9.5501 9.2568C11.2257 7.65549 13.4967 6.67188 15.9974 6.67188C21.1462 6.67188 25.3212 10.841 25.3308 15.9876ZM18.5222 18.9526L18.8919 18.4772C19.1982 18.0835 19.1272 17.516 18.7335 17.2098L17.2017 16.0184V12.0912C17.2017 11.5924 16.7973 11.188 16.2985 11.188H15.6963C15.1975 11.188 14.7931 11.5924 14.7931 12.0912V17.1964L17.2547 19.111C17.6485 19.4172 18.216 19.3463 18.5222 18.9526Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActivity);
export default ForwardRef;